import React from "react";

// ui
import { Label, FormFeedback } from "reactstrap";
import RequiredIndicator from "./RequiredIndicator";

const FormFieldGroup = (props) => {
	const { error, label, messageText, required } = props;
	const touched = false;
	const invalid = required && error && touched ? true : false;

	const styles = {
		display: invalid ? "block" : "block",
	};

	const messageStyles = {
		fontSize: ".95rem",
	};

	return (
		<div>
			<Label>
				{label} {required && <RequiredIndicator />}
			</Label>
			{props.children}
			<FormFeedback style={styles}>{error}</FormFeedback>
			<div style={messageStyles} className="mt-1">
				{messageText}
			</div>
		</div>
	);
};

export default FormFieldGroup;
